import * as React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  ListItemButton,
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

interface IRecordConflictDialogProps {
  handleClose: (e: React.MouseEvent<HTMLButtonElement>) => void;
  handleListItemClick: (record: unknown) => void;
  open: boolean;
  records: unknown[];
}

const RecordConflictDialog: React.FC<IRecordConflictDialogProps> = (props) => {
  return (
    <Dialog onClose={props.handleClose} open={props.open}>
      <DialogTitle id="simple-dialog-title">Multiple Records Found</DialogTitle>

      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          One or more of our records were matched to the provided member ID.
          Please select your member record:
        </DialogContentText>
      </DialogContent>
      <List>
        {props.records.map((record: unknown) => {
          const rec = record as {
            rowNumber: number;
            relationship: string;
            name: string;
            affiliateNumber: string;
            affiliateName: string;
          };
          return (
            <ListItem key={rec.rowNumber} disablePadding>
              <ListItemButton onClick={() => props.handleListItemClick(record)}>
                <ListItemAvatar>
                  <Avatar>
                    <PersonIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText>
                  {rec.relationship +
                    ': ' +
                    rec.name +
                    ', ' +
                    rec.affiliateNumber +
                    ' - ' +
                    rec.affiliateName}
                </ListItemText>
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Dialog>
  );
};

export default RecordConflictDialog;
